/**
 * 
 * @copyright     (c) 2025 Gist Applications Inc.
 * @author        Greg Olive greg@gist-apps.com
 * @package       gift-card-pro
 * 
 * /assets/js/React/Proxy/pages/GiftCardForm/_steps/CardDeliveryStep.js
 * Created:       Tue Jan 07 2025
 * Modified By:   Greg Olive
 * Last Modified: Thu Apr 17 2025
 */

import React, { useContext} from 'react';
import {FormContext} from "@proxy/_contexts";
import {
  CardDelivery,
  Footer,
} from "../_sections";

export default function CardDeliveryStep({
  togglePreview,
}) {

  const {
    settings,
    currentStep,
    bulkOrder,
    digitalEnabled,
    physicalEnabled,
  }  = useContext(FormContext);

  const shouldShowDeliveryStep = (digitalEnabled && physicalEnabled && !bulkOrder);

  return ((shouldShowDeliveryStep) ?
    <div className={currentStep === "card_delivery" ? "gc__step gc__step_active" : "gc__step gc__step_inactive"}>
      <CardDelivery />
      {settings?.global?.appearance?.form_theme === "classic" && (
        <Footer togglePreview={togglePreview} />
      )}
    </div>
  : null);
};
